import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import $ from "jquery";

const General = () => {

    const [data, setData] = useState([]);
    const [inId, setIntId] = useState([]);
    const getData = async () => {
        const { data } = await axios.get('/auth/general');
        setData(data);
        setIntId(data.id)
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const uploadChange = async (e) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        const { data } = await axios.post("/upload", formData);
        setSelectedFile(data);
    };

    useEffect(() => {
        getData();
        $('.nav-item').removeClass('active');
        $('.nav-item').each(function () {
            if ($(this).find('a').attr('href') === window.location.pathname) {
                $(this).addClass('active');
            }
        });
    }, []);


    return (
        <div className="page-content">
            <nav className="page-breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">دەستپێک</a></li>
                    <li className="breadcrumb-item active" aria-current="page">ڕێکخستنا گشتی</li>
                </ol>
            </nav>
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <h6 className="card-title">ڕێکخستناگشتی یا وێب سایتی  </h6>
                                </div>
                                <div className="col-md-12">
                                    <form onSubmit={(e) => {
                                        e.preventDefault();
                                        const formData = new FormData(e.target);
                                        const data = Object.fromEntries(formData);
                                        axios.put(`/auth/general/${inId}`, data).then(() => {
                                            toast.success('هاتە گهوڕین');
                                            setTimeout(() => {
                                                window.location.reload(true)
                                            }, 1000);
                                        })
                                    }} >
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">ناڤێ ویب سایت</label>
                                                    <input type="text" className="form-control" name="name" defaultValue={data.name} placeholder="ناڤێ ویب سایتی ..." required />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">ژ.مۆبایل</label>
                                                    <input type="text" className="form-control" name="phone_no" defaultValue={data.phone_no} placeholder="ژ.مۆبایل ...." required />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-3">
                                                    <label className="form-label">ئیمەیل</label>
                                                    <input type="text" className="form-control" name="email" defaultValue={data.email} placeholder="ئیەمیل ...." required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">پێناسە</label>
                                                    <textarea type="text" className="form-control" name="description" col={8} defaultValue={data.description} placeholder="پێناسە ...." required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">ناڤونیشان</label>
                                                    <textarea type="text" className="form-control" name="address" col={8} defaultValue={data.address} placeholder="ناڤونیشان ...." required />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">لۆگۆ</label>
                                                    <input type="file" className="form-control" onChange={uploadChange} accept="application/pdf, image/*" />
                                                    <input type="hidden" name="logo" defaultValue={selectedFile ? selectedFile : data.logo} />
                                                    <small className="text-muted">{data.logo}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="submit" className="btn btn-primary">گهوڕین</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default General;